import { FormattedMessage } from 'react-intl';

import * as S from './styles';
import { Band, Inner, SectionHead } from '../ui/Section';
import { PriceGroup, PriceGrid } from '../ui/PriceList';
import Reveal from '../ui/Reveal';
import { HandIcon } from '../ui/NailIcons';
import { FIBRA_DE_VIDRO } from '../../consts/prices';

const span = { span: (chunks) => <span>{chunks}</span> };

function FibraVidro() {
  return (
    <Band id="precos">
      <Inner>
        <SectionHead eyebrow={<FormattedMessage id="prices.eyebrow" />}>
          <FormattedMessage id="fibraVidro.title" values={span} />
        </SectionHead>

        <Reveal>
          <S.Intro>
            <HandIcon size={44} className="mark" />
            <p>
              <FormattedMessage id="fibraVidro.description" />
            </p>
          </S.Intro>
        </Reveal>

        <PriceGrid>
          <Reveal>
            <PriceGroup
              title={<FormattedMessage id="fibraVidro.application" />}
              items={FIBRA_DE_VIDRO.aplicacao}
            />
          </Reveal>
          <Reveal delay={80}>
            <PriceGroup
              title={<FormattedMessage id="fibraVidro.maintenance" />}
              items={FIBRA_DE_VIDRO.manutencao}
            />
          </Reveal>
          <Reveal delay={160}>
            <PriceGroup
              title={<FormattedMessage id="fibraVidro.additionals" />}
              items={FIBRA_DE_VIDRO.adicionais}
            />
          </Reveal>
        </PriceGrid>
      </Inner>
    </Band>
  );
}

export default FibraVidro;
